import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useCustomerData } from '../../customerData';
import { customerPageStyling } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { useCustomerBookingCart } from '../../selectedCustomerData';
import AddCustomerCar from '../../customerCarLayout/addCustomerCar';
import { EditCustomersCar } from '../../customerCarLayout/editCustomerCar';
import { CustomerCartServicess } from 'src/services/customer/customerCartServices';
import { enqueueSnackbar } from 'notistack';

export const SelectCar = (props) => {
  const { data, index, handelChangeCar, page } = props;

  const {
    setCartCards,
    selectedCustomerData,
    setSubscriptionCards,
    handleGetCustomerCarById,
    carList,
    addressList,
    cart,
    subscriptionCards,
    cartCardsData,
    refreshCartData
  } = useCustomerBookingCart();

  const { customerfuelType,allCars } = useCustomerData();
  const [addNewCar, setAddNewCar] = useState(false);
  const [editCar, setEditCar] = useState(false);
  const [carDataToEdit, setCarDataToEdit] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [displayedCars, setDisplayedCars] = useState([]);
  const [showFullList, setShowFullList] = useState(true);
  const [autoSelectedCar, setAutoSelectedCar] = useState(null);
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [pendingCardId, setPendingCardId] = useState<number | null>(null);
  const [reseted, setReseted] = useState(false);

  useEffect(() => {
    const fetchCars = async () => {
      setIsLoading(true);
      const updatedCars = await handleGetCustomerCarById();
      setDisplayedCars(Array.isArray(updatedCars) ? updatedCars : carList || []);
      setIsLoading(false);
    };

    fetchCars();
  }, []);

  useEffect(() => {
  if (
    Array.isArray(carList) &&
    carList.length > displayedCars.length 
  ) {
    setDisplayedCars(carList);
  }
}, [carList]);

  useEffect(() => {
    if (page === 'Subscription') {
      if (
        data.selectedCar === true &&
        data.car &&
        !Array.isArray(data.car) &&
        data.car.customerCarId
      ) {
        setShowFullList(false);
      } else {
        setShowFullList(true);
      }
    } else {
      if (!data.selectedCar || Array.isArray(data.car) || !data.car) {
        setShowFullList(true);
        setAutoSelectedCar(null);
      } else {
        setShowFullList(false);
      }
    }
  }, [data.selectedCar, data.car, page]);


  useEffect(() => {
    if (page === 'Booking' && cart && cart.cartServices && !autoSelectedCar) {
      const cartService = cart.cartServices?.find(
        (service) => service.customerCarId && service.cartId === cart.cartId
      );

      if (cartService && carList?.length > 0) {
        const carToSelect = carList?.find(
          (car) => car.customerCarId === cartService.customerCarId
        );

        if (carToSelect) {
          setAutoSelectedCar(carToSelect);
          handleSelectCar(carToSelect, data.id, true);
          setShowFullList(false);
        }
      }
    }
  }, [cart, carList, data.id]);

  const handleUpdateCarData = async (isSuccess, updatedCarData) => {
    if (isSuccess && updatedCarData) {
      const mappedCar = {
        customerCarId: updatedCarData.id,
        carId: updatedCarData.car?.id ?? data.car.carId,
        registrationNumber: updatedCarData.registrationNumber,
        carNickName: updatedCarData.carNickName,
        fuelTypeId: updatedCarData.fuelTypeId,
        passingYear: updatedCarData.passingYear,
        engineNumber: updatedCarData.engineNumber,
        chassisNumber: updatedCarData.chassisNumber,
        carColor: updatedCarData.carColor,
        isActive: updatedCarData.isActive,
        customerId: updatedCarData.customer?.id ?? data.car.customerId
      };

      setDisplayedCars((prev) =>
        prev?.map((car) =>
          car.customerCarId === mappedCar.customerCarId ? mappedCar : car
        )
      );

      const updateCards = (cards) =>
        cards?.map((card) =>
          card.car?.customerCarId === mappedCar.customerCarId
            ? { ...card, car: mappedCar }
            : card
        );

      page === 'Booking'
        ? setCartCards(updateCards)
        : setSubscriptionCards(updateCards);
    }

    setEditCar(false);
  };

  const handleSelectCar = (selectedCar, cardId, select) => {
    const updateCards = (cards) =>
      cards?.map((card) =>
        card.id === cardId
          ? { ...card, car: selectedCar, selectedCar: select }
           : card
      );

    page === 'Booking'
      ? setCartCards(updateCards)
      : setSubscriptionCards(updateCards);
  };

  const handleSelectOneCar = (car, cardId) => {
    setAutoSelectedCar(null);
    handleSelectCar(car, cardId, true);
    setShowFullList(false);
  };

  const handleChangeCar = async (cardId: number) => {
    const hasServices = page === 'Booking' && (data.services?.length ?? 0) > 0;
    const hasPackage = page === 'Subscription' && data.selectedPackage === true && data.package;

    if (hasServices || hasPackage) {
      setPendingCardId(cardId);
      setShowResetConfirm(true);
    } else {
      proceedToChangeCar(cardId, index);
    }
  };

  const proceedToChangeCar = (cardId: number, cardIndex: number) => {
    setAutoSelectedCar(null);
    setShowFullList(true);
    handelChangeCar(cardId, false, cardIndex);
  };

  const resetCart = async () => {
    try {
      const deletePromises: Promise<any>[] = [];

      if (page === "Booking") {
        if (cart?.cartServices?.length > 0) {
          cart.cartServices.forEach(service => {
            deletePromises.push(
              CustomerCartServicess.removeServiceFromCart(service.cartServiceId)
            );
          });
        }
      }

      if (page === "Subscription") {
        const targetCard = subscriptionCards?.find(c => c.id === data.id);
        if (targetCard?.cartSubscriptionId) {
          await CustomerCartServicess.removeSubscriptionFromCart(targetCard.cartSubscriptionId);
        }
        await refreshCartData();
      }

      if (deletePromises.length > 0) {
        await Promise.all(deletePromises);
        await refreshCartData();
      }

      if (page === "Booking") {
  setCartCards(prev => {
    return prev?.map(card => {
      return card.id === data.id
        ? {
            ...card,
            car: [],
            selectedCar: false,
            address: [],
            selectedAddress: false,
            services: [],
            totalAmount: 0,
            taxAmount: 0,
            discountAmount: 0
          }
        : card;
    });
  });
}

      if (page === "Subscription") {
        setSubscriptionCards(prev => {
          return prev?.map(card => {
            return card.id === data.id
              ? {
                ...card,
                car: [],
                selectedCar: false,
                address: addressList?.addresses?.filter(
                  x => x.cityID === selectedCustomerData.city.id
                ) || [],
                selectedAddress: false,
                package: [],
                selectedPackage: false,
                totalAmount: 0,
                taxAmount: 0,
                discountAmount: 0
              }
              : card;
          });
        });
      }

    } catch (error) {
      enqueueSnackbar("Error resetting cart", { variant: "error" });
    }
  };

  const renderSelectedCarView = () => (

    <div style={customerPageStyling.selects.car.container}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          <tr style={{ backgroundColor: '#fff', textAlign: 'center' }}>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {data.car.customerCarId}
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {allCars?.find((c) => c.id === data.car.carId)?.name}
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {data.car.registrationNumber}
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {customerfuelType?.find((fuel) => fuel.id === data.car.fuelTypeId)?.name}
            </td>
            <td style={{ padding: '10px', textAlign: 'right' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setCarDataToEdit(data.car);
                    setEditCar(true);
                  }}
                >
                  Edit
                </Button>
                <Button onClick={() => handleChangeCar(data.id)}>Change</Button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const renderFullListView = () => (
    <div style={customerPageStyling.selects.car.container}>
      {isLoading ? (
        <div style={customerPageStyling.selects.car.elseHolders}>
          <span>Loading cars...</span>
        </div>
      ) : displayedCars.length > 0 ? (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {displayedCars?.map((car, index) => (
              <tr
                key={`${car.customerCarId}-${index}`}
                style={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                  textAlign: 'center'
                }}
              >
                <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                  {car.customerCarId}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                {allCars?.find((c) => c.id === car.carId)?.name}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                  {car.registrationNumber}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                  {customerfuelType?.find((fuel) => fuel.id === car.fuelTypeId)?.name}
                </td>
                <td style={{ padding: '10px', textAlign: 'right' }}>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      style={{ marginRight: '5px' }}
                      onClick={() => {
                        setCarDataToEdit(car);
                        setEditCar(true);
                      }}
                    >
                      Edit
                    </Button>
                    <Button onClick={() => handleSelectOneCar(car, data.id)}>
                      Select
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div style={customerPageStyling.selects.car.elseHolders}>
          <span>No cars found. Please add a car.</span>
        </div>
      )}
    </div>
  );

  return (
    <>
      <div style={customerPageStyling.selects.header_btn}>
        <Typography variant="h4">
          {showFullList ? 'Customer Cars' : 'Selected Car'}
        </Typography>

        {showFullList && (
          <Button
            color="primary"
            variant="contained"
            onClick={() => setAddNewCar(true)}
          >
            + Add Car
          </Button>
        )}

        <AddCustomerCar
          open={addNewCar}
          editData=""
          data={selectedCustomerData}
          type={editCar}
          Lable="ADD NEW CAR"
          description="Enter Car"
          addBtn="ADD CAR"
          handleClose={async () => {
            setAddNewCar(false);
            const cars = await handleGetCustomerCarById();
            setDisplayedCars(cars || []);
          }}
        />
      </div>

      {data.selectedCar && !Array.isArray(data.car) && data.car
        ? renderSelectedCarView()
        : renderFullListView()}

      <Dialog
        open={editCar}
        onClose={() => setEditCar(false)}
        maxWidth="md"
        fullWidth
      >
        <EditCustomersCar
          open={editCar}
          rowData={carDataToEdit}
          data={carList}
          handleEditeData={handleUpdateCarData}
          handleClose={() => setEditCar(false)}
        />
      </Dialog>

      {/* Reset Confirmation Dialog */}
      <Dialog
        open={showResetConfirm}
        onClose={() => {
          setShowResetConfirm(false);
          setPendingCardId(null);
        }}
      >
        <DialogTitle>Reset Cart?</DialogTitle>
        <DialogContent>
          Changing the selected car will reset your cart. Do you want to continue?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowResetConfirm(false);
              setPendingCardId(null);
            }}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={async () => {
              if (pendingCardId !== null) {
                await resetCart();
                setAutoSelectedCar(null);
              }
              setShowResetConfirm(false);
              setPendingCardId(null);
            }}
          >
            Yes, Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
